// extracted by mini-css-extract-plugin
module.exports = {"confirmation-lab-table":"ConfirmationLabTable_confirmation-lab-table__2Fh0r"};